
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import PlatformMarkerJungleLogKnot from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogKnot";
import RelicMarker from "../../editor/RelicMarker";
import PlatformMarkerCabin from "../../editor/platform-markers/shipwreck/PlatformMarkerCabin";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
import PlatformMarkerJungleLogLong from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogLong";
import PlatformMarkerSubmergedBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerSubmergedBarrel";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckChunkRelic2 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 586, y ?? 502);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 3462, 7);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -848, 7);
    this.add(editor_bounds_left);

    // platformLogKnot
    const platformLogKnot = new PlatformMarkerJungleLogKnot(scene, 1886, -532);
    this.add(platformLogKnot);

    // relicMarker
    const relicMarker = new RelicMarker(scene, 1886, -614);
    this.add(relicMarker);

    // platformLogKnot_1
    const platformLogKnot_1 = new PlatformMarkerJungleLogKnot(scene, 1072, -537);
    this.add(platformLogKnot_1);

    // platformCabin
    const platformCabin = new PlatformMarkerCabin(scene, 1839, -59);
    this.add(platformCabin);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 473, -495);
    this.add(gemMarker_9);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 533, -495);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 2562, -330);
    this.add(gemMarker_11);

    // editor_bounds_left_1
    const editor_bounds_left_1 = new BoundsMarker(scene, -809, 7);
    this.add(editor_bounds_left_1);

    // pole_long_float_png_1
    const pole_long_float_png_1 = new DecorationFloatingPoleLong(scene, -489, -121);
    this.add(pole_long_float_png_1);

    // pole_long_float_png
    const pole_long_float_png = new DecorationFloatingPoleLong(scene, -763, -121);
    this.add(pole_long_float_png);

    // platformLog_5
    const platformLog_5 = new PlatformMarkerJungleLog(scene, 441, -434);
    this.add(platformLog_5);

    // gemMarker_30
    const gemMarker_30 = new SmallGemMarker(scene, 504, -550);
    this.add(gemMarker_30);

    // gemMarker_31
    const gemMarker_31 = new SmallGemMarker(scene, -606, -324);
    this.add(gemMarker_31);

    // platformMarkerLogLong
    const platformMarkerLogLong = new PlatformMarkerJungleLogLong(scene, -356, -262);
    this.add(platformMarkerLogLong);

    // pole_long_float_png_8
    const pole_long_float_png_8 = new DecorationFloatingPoleLong(scene, -198, -121);
    this.add(pole_long_float_png_8);

    // pole_long_float_png_9
    const pole_long_float_png_9 = new DecorationFloatingPoleLong(scene, 72, -121);
    this.add(pole_long_float_png_9);

    // gemMarker_32
    const gemMarker_32 = new SmallGemMarker(scene, 2792, -331);
    this.add(gemMarker_32);

    // gemMarker_33
    const gemMarker_33 = new SmallGemMarker(scene, 3023, -334);
    this.add(gemMarker_33);

    // pole_long_float_png_2
    const pole_long_float_png_2 = new DecorationFloatingPoleLong(scene, 3106, -124);
    this.add(pole_long_float_png_2);

    // pole_long_float_png_3
    const pole_long_float_png_3 = new DecorationFloatingPoleLong(scene, 2842, -124);
    this.add(pole_long_float_png_3);

    // pole_long_float_png_4
    const pole_long_float_png_4 = new DecorationFloatingPoleLong(scene, 2551, -124);
    this.add(pole_long_float_png_4);

    // pole_long_float_png_5
    const pole_long_float_png_5 = new DecorationFloatingPoleLong(scene, 2278, -124);
    this.add(pole_long_float_png_5);

    // platformMarkerLogLong_1
    const platformMarkerLogLong_1 = new PlatformMarkerJungleLogLong(scene, 2692, -254);
    this.add(platformMarkerLogLong_1);

    // platformMarkerSubmergedBarrel
    const platformMarkerSubmergedBarrel = new PlatformMarkerSubmergedBarrel(scene, 901, -27);
    this.add(platformMarkerSubmergedBarrel);

    // platformMarkerSubmergedBarrel_2
    const platformMarkerSubmergedBarrel_2 = new PlatformMarkerSubmergedBarrel(scene, 1401, -28);
    this.add(platformMarkerSubmergedBarrel_2);

    // platformMarkerSubmergedBarrel_3
    const platformMarkerSubmergedBarrel_3 = new PlatformMarkerSubmergedBarrel(scene, 418, -24);
    this.add(platformMarkerSubmergedBarrel_3);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -607, -290);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 2339, -286);
    this.add(checkpointMarker_1);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 1147, -653);
    this.add(gemMarker_1);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 1145, -709);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 1147, -594);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 1203, -675);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 1203, -620);
    this.add(gemMarker_8);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1261, -648);
    this.add(gemMarker);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, -67, -316);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, -7, -316);
    this.add(gemMarker_3);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, -36, -371);
    this.add(gemMarker_4);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
